// @flow

import styled from '@emotion/styled'
import * as React from 'react'

import { colors, media } from '@toggl/style'

export default function Links({
  children,
  ...props
}: {
  children: React.Node,
}) {
  return (
    <StyledLinks {...props}>
      {React.Children.map(children, (a, index) => (
        <ExpandableLi key={index}>
          <BorderBottom>{a}</BorderBottom>
        </ExpandableLi>
      ))}
    </StyledLinks>
  )
}

const BorderBottom = styled.div`
  ${media.mq[1]} {
    &:hover {
      border-bottom: 1px solid;
    }
    border-bottom: 1px solid
      ${(p) => (p.active ? colors.darkPurple : 'transparent')};
  }
  > * {
    margin-bottom: 15px;
    display: flex;
  }
`

const StyledLinks: React.ComponentType<any> = styled.ul`
  display: flex;
  flex-direction: column;
  list-style-type: none;
  padding: 0;
  margin: 0;

  ${media.mq[1]} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    & > li {
      margin-bottom: 0;
      a {
        min-height: 24px;
      }
    }
  }
`

const ExpandableLi = styled.li`
  display: flex;
  ${media.mq[1]} {
    align-items: center;
  }
`
